import { render, staticRenderFns } from "./ChannelOnboardFormModal.vue?vue&type=template&id=43bf57ff&scoped=true"
import script from "./ChannelOnboardFormModal.vue?vue&type=script&lang=js"
export * from "./ChannelOnboardFormModal.vue?vue&type=script&lang=js"
import style0 from "./ChannelOnboardFormModal.vue?vue&type=style&index=0&id=43bf57ff&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43bf57ff",
  null
  
)

export default component.exports